import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.jsx'
import './index.css'
import { GlobalErrorBoundary } from './GlobalErrorBoundary.jsx'

const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <GlobalErrorBoundary>
                <App />
            </GlobalErrorBoundary>
        </QueryClientProvider>
    </React.StrictMode>,
)
